import React, { lazy } from 'react';

const ArticleParagraphComponent = lazy(
  () => import('../BlockComponents/ArticleParagraphComponent'),
);

const BlogBannerComponent = lazy(
  () => import('../BlockComponents/BlogBannerComponent'),
);

const TableOfContentComponent = lazy(
  () => import('../BlockComponents/TableOfContentComponent'),
);
const ArticleCalloutComponent = lazy(
  () => import('../BlockComponents/ArticleCalloutComponent'),
);
const BlogExampleComponent = lazy(
  () => import('../BlockComponents/BlogExampleComponent'),
);
const CalloutV2Component = lazy(
  () => import('../BlockComponents/CalloutV2Component'),
);
const MediaShareLinksComponent = lazy(
  () => import('../BlockComponents/MediaShareLinksComponent'),
);
const AnnualLeaveCalculatorComponent = lazy(
  () => import('../BlockComponents/AnnualLeaveCalculatorComponent'),
);
const BlogSummary = lazy(
  () => import('libs/brand-system/src/components/BlogSummary'),
);
const CalloutComponent = lazy(
  () => import('../BlockComponents/CalloutComponent'),
);

const ImageBlockComponent = lazy(
  () => import('../BlockComponents/ImageBlockComponent'),
);
const ToRememberComponent = lazy(
  () => import('../BlockComponents/ToRememberComponent'),
);
const TableComponent = lazy(() => import('../BlockComponents/TableComponent'));
const BlogQuoteComponent = lazy(
  () => import('../BlockComponents/BlogQuoteComponent'),
);
const ArticleAskADemoLinkComponent = lazy(
  () => import('../BlockComponents/ArticleAskADemoLinkComponent'),
);
const TrackingVideoComponent = lazy(
  () => import('../BlockComponents/TrackingVideoComponent'),
);
const GovernmentWidgetComponent = lazy(
  () => import('../BlockComponents/GovernmentWidgetComponent'),
);
const BackdatedPayCalculatorUKComponent = lazy(
  () => import('../BlockComponents/BackdatedPayCalculatorUKComponent'),
);
const EmbedSpotifyComponent = lazy(
  () => import('../BlockComponents/EmbedSpotifyComponent'),
);
const EmbedAushaComponent = lazy(
  () => import('../BlockComponents/EmbedAushaComponent'),
);
const EmbedArcadeComponent = lazy(
  () => import('../BlockComponents/EmbedArcadeComponent'),
);
const EmbedYoutubeComponent = lazy(
  () => import('../BlockComponents/EmbedYoutubeComponent'),
);
const EmbedVimeoComponent = lazy(
  () => import('../BlockComponents/EmbedVimeoComponent'),
);
const EmbedDailymotionComponent = lazy(
  () => import('../BlockComponents/EmbedDailymotionComponent'),
);

export const BlocksTypeArticle = ({
  block,
  locale,
  index,
  headingElementsRef,
  sidebarRef,
  headings,
}: any) => {
  if (block.__typename === 'DatoCmsParagraph')
    return (
      <ArticleParagraphComponent
        key={index}
        block={block}
        index={index}
        headingElementsRef={headingElementsRef}
      />
    );
  if (block.__typename === 'DatoCmsSummary')
    return (
      <div key={index} className="my-24 md:my-40">
        <BlogSummary text={block.text} />
      </div>
    );
  if (block.__typename === 'DatoCmsMediaShareLinks')
    return (
      <div key={index} className="my-24 md:my-40">
        <MediaShareLinksComponent
          url={block.url}
          locale={locale}
          title={block.title}
          copylinkDisabled={block.copylinkDisabled}
          linkedinDisabled={block.linkedinDisabled}
          metaDisabled={block.metaDisabled}
          xDisabled={block.xDisabled}
        />
      </div>
    );
  if (block.__typename === 'DatoCmsArticleCallout')
    return <ArticleCalloutComponent block={block} key={index} />;
  if (block.__typename === 'DatoCmsAnnualLeaveCalculator')
    return <AnnualLeaveCalculatorComponent block={block} key={index} />;
  if (block.__typename === 'DatoCmsTableOfContent') {
    //isStickyToTop
    return (
      <div ref={sidebarRef} key={index}>
        <TableOfContentComponent
          block={block}
          headings={headings}
          headingElementsRef={headingElementsRef}
          className="block lg:hidden"
        />
      </div>
    );
  }
  if (block.__typename === 'DatoCmsBlogBannerBlock') {
    return (
      <div className="my-24 md:my-40 xl:w-3/4" key={index}>
        <BlogBannerComponent
          block={block}
          ctaData={{
            className: 'w-full',
            isTitleResponsive: true,
          }}
          index={index}
        />
      </div>
    );
  }
  if (block.__typename === 'DatoCmsImageBlock')
    return <ImageBlockComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsToRemember')
    return <ToRememberComponent block={block} key={index} />;
  if (block.__typename === 'DatoCmsCallout') {
    return (
      <div className="my-24 md:my-40" key={index}>
        <CalloutComponent block={block} locale={locale} index={index} />
      </div>
    );
  }
  if (block.__typename === 'DatoCmsCalloutV2')
    return <CalloutV2Component block={block} />
  if (block.__typename === 'DatoCmsTable')
    return <TableComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsBlogExample')
    return <BlogExampleComponent block={block} index={index} key={index} />;
  if (block.__typename === 'DatoCmsBlogQuote')
    return <BlogQuoteComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsAskADemoLink')
    return <ArticleAskADemoLinkComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsRecommendation') {
    return (
      <div className="my-24 md:my-40" key={index}>
        <BlogBannerComponent
          title={block?.title}
          image={block?.image}
          index={index}
        />
      </div>
    );
  }

  if (block.__typename === 'DatoCmsVideo')
    return <TrackingVideoComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsGovernmentWidget')
    return <GovernmentWidgetComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsBackdatedPayCalculatorUk')
    return <BackdatedPayCalculatorUKComponent key={index} block={block} />;
  if (block.__typename === 'DatoCmsEmbedSpotify') {
    return <EmbedSpotifyComponent key={index} block={block} />;
  }
  if (block.__typename === 'DatoCmsEmbedAusha') {
    return <EmbedAushaComponent key={index} block={block} />;
  }
  if (block.__typename === 'DatoCmsEmbedArcade') {
    return <EmbedArcadeComponent key={index} block={block} />;
  }
  if (block.__typename === 'DatoCmsEmbedYoutube') {
    return <EmbedYoutubeComponent key={index} block={block} />;
  }
  if (block.__typename === 'DatoCmsEmbedVimeo') {
    return <EmbedVimeoComponent key={index} block={block} />;
  }
  if (block.__typename === 'DatoCmsEmbedDailymotion') {
    return <EmbedDailymotionComponent key={index} block={block} />;
  }
};
